import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable()
export class ConfigService {
  private config: any;
  private isFetching: Promise<any> = null; // Use a promise to ensure only one request is live at a time
  private baseUrlCache: string = null;

  constructor(private http: HttpClient) {}

  get(key: string) {
    if (!Object.prototype.hasOwnProperty.call(this.config, key)) {
      return null;
    }
    return this.config[key];
  }

  baseUrl(): string {
    if (!this.baseUrlCache) {
      this.baseUrlCache = document.baseURI;
      if (!this.baseUrlCache) {
        const baseTags = document.getElementsByTagName('base');
        if (baseTags && baseTags.length > 0) {
          this.baseUrlCache = baseTags[0].href;
        } else {
          this.baseUrlCache = window.location.href;
        }
      }
      this.baseUrlCache = this.baseUrlCache.replace(/\/+$/, '');
    }
    return this.baseUrlCache;
  }

  apiUrl(): string {
    return `${this.baseUrl()}/api/v1`;
  }

  initialize() {
    if (this.isFetching) {
      return this.isFetching;
    }
    this.isFetching = this.http
      .get(`${this.apiUrl()}/config`)
      .toPromise()
      .then(
        config => {
          this.config = {
            isProduction: false,
            ...config
          };
          this.isFetching = null;
          return this.config;
        },
        err => {
          this.isFetching = null;
          throw err;
        }
      );
    return this.isFetching;
  }
}
